import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { PendingButton } from "@ploy-ui/core";
export function FormikSubmitButton(props) {
    const formik = useFormikContext();
    return (_jsx(PendingButton, { ...props, type: "submit", success: false, pending: formik.isSubmitting, onClick: formik.submitForm }));
}
export function FormikResetButton(props) {
    const formik = useFormikContext();
    return (_jsx(PendingButton, { ...props, type: "reset", success: false, disabled: formik.isSubmitting, onClick: formik.handleReset }));
}
//# sourceMappingURL=FormikSubmitButton.js.map